
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/card-cadou",
      function () {
        return require("private-next-pages/card-cadou.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/card-cadou"])
      });
    }
  